import React from 'react';
//import PropTypes from 'prop-types';

import { createUseStyles } from '../palette';
import decorate from '../common/utils/decorate';
import * as component from '../common/utils/component';
import DeliveryWidgetContext from '../contexts/DeliveryWidgetContext';
import Button from '../ui/Button';
import Checkbox from '../ui/Checkbox';
import Icon from '../ui/Icon';
import Text from '../ui/Text';

const useStyles = createUseStyles((theme) => ({
  agreementChildren: {
    flexGrow: 0
  },
  
  iconBtn: {
    marginTop: -10
  },
  
  line: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.getFactor('checkbox', 'indent', 0.5)
  }
}));

export default decorate(
  class extends React.PureComponent {
    static contextType = DeliveryWidgetContext;
    
    static decorateWith = {
      classes: useStyles
    };
    
    static propTypes = {};
    
    static defaultProps = {};
    
    constructor(props) {
      super(props);
    }
    
    componentDidMount() {}
    
    componentWillUnmount() {}
    
    componentDidUpdate(prevProps, prevState, snapshot) {}
    
    render() {
      const {
        classes,
        agreements,
        setChecked,
        onAgreementShow
      } = this.props;
      
      const { langString } = this.context;
      
      if (!agreements?.length)
        return null;
      
      return (
        <>
          {setChecked ? (
            <Text color="hint" size="sm">{langString('agreement.all')}</Text>
          ) : null}
          
          {agreements.map((agreement, index) => {
            const agreementTitle = langString(agreement.title);
            const agreementTitle2 = langString(agreement.title2);
            const agreementLink = langString(agreement.link);
            const agreementContent = langString(agreement.content);
            
            if (setChecked) {
              return (
                <Checkbox
                  key={index}
                  size="large"
                  childrenClassName={classes.agreementChildren}
                  endAdornment={
                    agreementLink || agreementContent ? (
                      <Button
                        variant="icon"
                        color="secondary"
                        className={classes.iconBtn}
                        onClick={onAgreementShow(agreement)}
                      >
                        <Icon
                          name={agreementLink ? 'openInNew' : 'findInPage'}
                          color="primary"
                          size="xl"
                        />
                      </Button>
                    ) : null
                  }
                  checked={!!agreement.checked}
                  onChange={(event) => {
                    const checked = event.target.checked;
                    
                    setChecked(index, checked);
                  }}
                >
                  <Text key="title" color="hint">{agreementTitle2 || agreementTitle}</Text>
                </Checkbox>
              );
            } else {
              return (
                <div
                  key={index}
                  className={classes.line}
                >
                  <Text key="title" color="hint">{agreementTitle2 || agreementTitle}</Text>
                  <div>
                    {agreementLink || agreementContent ? (
                      <Button
                        variant="icon"
                        color="secondary"
                        className={classes.iconBtn}
                        onClick={onAgreementShow(agreement)}
                      >
                        <Icon
                          name={agreementLink ? 'openInNew' : 'findInPage'}
                          color="primary"
                          size="xl"
                        />
                      </Button>
                    ) : null}
                  </div>
                </div>
              );
            }
          })}
        </>
      );
    }
  }
);
